import { ReactComponent as OfflineHomeIcon } from 'images/OfflineHomeIcon.svg'

import {
  NotAvailableHostContainer,
  NotAvailableHostLabel,
  NotAvailableHostTextContainer,
  NotAvailableHostTitle,
  NotAvailableHostCaptions,
} from './styles'

interface NotAvailableHostProps {
  title: string
  captions: string[]
}

function NotAvailableHost({ title, captions }: NotAvailableHostProps) {
  return (
    <NotAvailableHostContainer>
      <OfflineHomeIcon />
      <NotAvailableHostTextContainer>
        <NotAvailableHostTitle>{title}</NotAvailableHostTitle>

        <NotAvailableHostCaptions>
          {captions.map((caption, idx) => {
            return (
              <NotAvailableHostLabel key={idx}>{caption}</NotAvailableHostLabel>
            )
          })}
        </NotAvailableHostCaptions>
      </NotAvailableHostTextContainer>
    </NotAvailableHostContainer>
  )
}

export default NotAvailableHost
